import { COMPANY_SIZE_OPTIONS, createBetaAccessRequestSchema } from "@crewledger/shared/beta-access";
import { apiFetch } from "@/lib/api";

export { COMPANY_SIZE_OPTIONS, createBetaAccessRequestSchema };

export async function submitBetaAccessRequest(
  input: unknown,
): Promise<void> {
  const parsed = createBetaAccessRequestSchema.parse(input);

  await apiFetch("/api/access-requests", {
    method: "POST",
    body: JSON.stringify(parsed),
  });
}
